export type FormFields = {
  size: number | string;
  stoploss: number | string;
  takeprofit: number | string;
  type: number | string;
  description: string;
  price?: number | string;
  timeout?: number | string;
};

export type SubmissionState = 'idle' | 'pending' | 'unknown';

export enum ComplexOrderProcessorType {
  Mock = 0,
  Market = 1,
  Steps = 2,
  MarketOnly = 3,
  Negotiation = 4,
  Vwap = 5,
  SpreadSteps = 6,
  Limit = 12,
}

export type MarketSignal = {
  weight: number;
  strategyId: string;
  symbol: string;
  classCode: string;
  board: string;
  comment: string;
  stopLoss?: number;
  takeProfit?: number;
  typeSignal?: number;
};

export type LimitSignal = MarketSignal & {
  price?: number;
  timeout?: number;
};

export type DelayedSignal = MarketSignal & {
  timeout?: number;
  execQuotation?: number;
  tradeType?: ComplexOrderProcessorType;
};
